import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=4d24382e&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=4d24382e&prod&lang=css"
import style1 from "./ContentItem.vue?vue&type=style&index=1&id=4d24382e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d24382e",
  null
  
)

export default component.exports